"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../../../reducers");
class APITriggerPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = { tab: 'GraphQL' };
    }
    render() {
        const { tab } = this.state;
        return (React.createElement("div", { id: "code-preview", style: {
                width: '80%',
                position: 'absolute',
                top: 80
            } },
            React.createElement("style", { type: "text/css" }, `
                    #code-preview>pre {
                        overflow-x: scroll;
                        counter-reset: line;
                        line-height: 24px;
                        display: grid;
                        background: #fbfbfb;
                    }
                    
                    #code-preview>pre>code {
                        counter-increment: line;
                    }
                    
                    #code-preview>pre>code::before {
                        background: #f5f5f5;
                        content: counter(line);
                        display: inline-block;
                        text-align: right;
                        width: 1.5em;
                        padding: 0 0.2em;
                        margin-right: 8px;
                        color: #888;
                        -webkit-user-select: none;
                    }
                    
                `),
            React.createElement(src_1.TabBar, null,
                React.createElement(src_1.Tab, { val: "GraphQL", selected: tab, onClick: () => this.setState({ tab: 'GraphQL' }) }),
                React.createElement(src_1.Tab, { val: "cURL", selected: tab, onClick: () => this.setState({ tab: 'cURL' }) })),
            tab === 'GraphQL' ? (React.createElement(React.Fragment, null,
                React.createElement(src_1.Text, { text: "QUERY", size: "small", textStyle: Object.assign({ marginTop: 24, marginLeft: 24, fontFamily: 'monospace' }, src_1.semibold) }),
                this.getGraphQLQueryHTML(),
                React.createElement(src_1.Text, { text: "VARIABLES", size: "small", textStyle: Object.assign({ marginTop: 24, marginLeft: 24, fontFamily: 'monospace' }, src_1.semibold) }),
                this.getGraphQLVariablesHTML())) : (React.createElement(React.Fragment, null,
                React.createElement(src_1.Text, { text: "COMMAND", size: "small", textStyle: Object.assign({ marginTop: 24, marginLeft: 24, fontFamily: 'monospace' }, src_1.semibold) }),
                this.getCurlCommandHTML()))));
    }
    getGraphQLQueryHTML() {
        const { trigger } = this.props.campaign;
        const { fields } = trigger;
        if (fields.length === 0) {
            return (React.createElement("pre", null,
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } }),
                React.createElement("code", null,
                    React.createElement("span", { style: { color: '#B01A03' } }, "mutation"),
                    ' ',
                    React.createElement("span", { style: { color: '#D2074E' } }, "CampaignSendNotification"),
                    "(",
                    React.createElement("span", { style: { color: '#397D13' } }, "$id"),
                    ":",
                    React.createElement("span", { style: { color: '#CA9802' } }, " ID"),
                    "!,",
                    React.createElement("span", { style: { color: '#397D13' } }, " $to"),
                    ": [",
                    React.createElement("span", { style: { color: '#CA9802' } }, "String"),
                    "!]!)",
                    ' {'),
                React.createElement("code", null,
                    '    ',
                    React.createElement("span", { style: { color: '#2061A0' } }, "campaignSendNotification"),
                    "(",
                    React.createElement("span", { style: { color: '#8A2BB9' } }, "id"),
                    ":",
                    React.createElement("span", { style: { color: '#397D13' } }, " $id"),
                    ",",
                    React.createElement("span", { style: { color: '#8A2BB9' } }, " to"),
                    ":",
                    React.createElement("span", { style: { color: '#397D13' } }, " $to"),
                    ")"),
                React.createElement("code", null, "}"),
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } })));
        }
        return (React.createElement("pre", null,
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } }),
            React.createElement("code", null,
                React.createElement("span", { style: { color: '#B01A03' } }, "mutation"),
                ' ',
                React.createElement("span", { style: { color: '#D2074E' } }, "CampaignSendNotification"),
                "(",
                React.createElement("span", { style: { color: '#397D13' } }, "$id"),
                ":",
                React.createElement("span", { style: { color: '#CA9802' } }, " ID"),
                "!,",
                React.createElement("span", { style: { color: '#397D13' } }, " $to"),
                ": [",
                React.createElement("span", { style: { color: '#CA9802' } }, "String"),
                "!]!,",
                React.createElement("span", { style: { color: '#397D13' } }, " $fields"),
                ":",
                React.createElement("span", { style: { color: '#CA9802' } }, " JSON"),
                '!) {'),
            React.createElement("code", null,
                '    ',
                React.createElement("span", { style: { color: '#2061A0' } }, "campaignSendNotification"),
                "(",
                React.createElement("span", { style: { color: '#8A2BB9' } }, "id"),
                ":",
                React.createElement("span", { style: { color: '#397D13' } }, " $id"),
                ",",
                React.createElement("span", { style: { color: '#8A2BB9' } }, " to"),
                ":",
                React.createElement("span", { style: { color: '#397D13' } }, " $to"),
                ",",
                React.createElement("span", { style: { color: '#8A2BB9' } }, " fields"),
                ":",
                React.createElement("span", { style: { color: '#397D13' } }, " $fields"),
                ")"),
            React.createElement("code", null, "}"),
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } })));
    }
    getGraphQLVariablesHTML() {
        const { id, trigger } = this.props.campaign;
        const { fields } = trigger;
        if (fields.length === 0) {
            return (React.createElement("pre", null,
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } }),
                React.createElement("code", null, '{'),
                React.createElement("code", null,
                    '  ',
                    React.createElement("span", { style: { color: '#397D13' } }, "\"id\""),
                    ":",
                    React.createElement("span", { style: { color: '#D64292' } },
                        " ",
                        id),
                    ","),
                React.createElement("code", null,
                    '  ',
                    React.createElement("span", { style: { color: '#397D13' } }, "\"to\""),
                    ": [",
                    React.createElement("span", { style: { color: '#D64292' } }, "\"DEVICE_ID\", ..."),
                    "]"),
                React.createElement("code", null, '}'),
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } })));
        }
        return (React.createElement("pre", null,
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } }),
            React.createElement("code", null, '{'),
            React.createElement("code", null,
                '  ',
                React.createElement("span", { style: { color: '#397D13' } }, "\"id\""),
                ":",
                React.createElement("span", { style: { color: '#D64292' } },
                    " ",
                    id),
                ","),
            React.createElement("code", null,
                '  ',
                React.createElement("span", { style: { color: '#397D13' } }, "\"to\""),
                ": [",
                React.createElement("span", { style: { color: '#D64292' } }, "\"DEVICE_ID\", ..."),
                "],"),
            React.createElement("code", null,
                '  ',
                React.createElement("span", { style: { color: '#397D13' } }, "\"fields\""),
                ":",
                ` {`),
            fields.map((field, index) => {
                if (index === fields.length - 1) {
                    return (React.createElement("code", { key: index },
                        '    ',
                        React.createElement("span", { style: { color: '#8A2BB9' } },
                            "\"",
                            field,
                            "\""),
                        ":",
                        React.createElement("span", { style: { color: '#D64292' } },
                            ' ',
                            "\"",
                            field.toUpperCase(),
                            "\"")));
                }
                return (React.createElement("code", { key: index },
                    '    ',
                    React.createElement("span", { style: { color: '#8A2BB9' } },
                        "\"",
                        field,
                        "\""),
                    ":",
                    React.createElement("span", { style: { color: '#D64292' } },
                        ' ',
                        "\"",
                        field.toUpperCase(),
                        "\""),
                    ","));
            }),
            React.createElement("code", null, `  }`),
            React.createElement("code", null, '}'),
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } })));
    }
    getCurlCommandHTML() {
        const { id, trigger } = this.props.campaign;
        const { fields } = trigger;
        if (fields.length === 0) {
            return (React.createElement("pre", null,
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } }),
                React.createElement("code", null,
                    React.createElement("span", { style: { color: '#B01A03' } }, "curl"),
                    " -X",
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, "'POST'"),
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, process.env.NODE_ENV === 'production'
                        ? `'https://api.rover.io/graphql'`
                        : `'https://api.staging.rover.io/graphql'`),
                    ' ',
                    "\\"),
                React.createElement("code", null,
                    '  ',
                    "-H",
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, "'accept: application/json'"),
                    ' ',
                    "\\"),
                React.createElement("code", null,
                    '  ',
                    "-H",
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, "'content-type: application/json'"),
                    ' ',
                    "\\"),
                React.createElement("code", null,
                    '  ',
                    "-H",
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, "'x-rover-api-key:"),
                    React.createElement("span", { style: { color: '#D64292' } }, " SERVER_TOKEN"),
                    React.createElement("span", { style: { color: '#669900' } }, "'"),
                    " \\"),
                React.createElement("code", null,
                    '  ',
                    "--data-binary",
                    ' ',
                    React.createElement("span", { style: { color: '#669900' } }, `'{`)),
                React.createElement("code", null,
                    '    ',
                    React.createElement("span", { style: { color: '#669900' } }, `"variables": {`)),
                React.createElement("code", null,
                    '      ',
                    React.createElement("span", { style: { color: '#669900' } }, "\"id\":"),
                    React.createElement("span", { style: { color: '#D64292' } },
                        " ",
                        id),
                    React.createElement("span", { style: { color: '#669900' } }, ",")),
                React.createElement("code", null,
                    '      ',
                    React.createElement("span", { style: { color: '#669900' } }, "\"to\": ["),
                    React.createElement("span", { style: { color: '#D64292' } }, "\"DEVICE_ID\", ..."),
                    React.createElement("span", { style: { color: '#669900' } }, "]")),
                React.createElement("code", null,
                    '    ',
                    React.createElement("span", { style: { color: '#669900' } }, "},")),
                React.createElement("code", null,
                    '    ',
                    React.createElement("span", { style: { color: '#669900' } }, "\"operationName\": \"CampaignSendNotification\",")),
                React.createElement("code", null,
                    '    ',
                    React.createElement("span", { style: { color: '#669900' } }, `"query": "mutation CampaignSendNotification($id:ID!,$to:[String!]!){campaignSendNotification(id:$id,to:$to)}"`)),
                React.createElement("code", null,
                    '  ',
                    React.createElement("span", { style: { color: '#669900' } }, `}'`)),
                React.createElement("div", { style: {
                        height: 16,
                        width: '1.5em',
                        background: '#f5f5f5'
                    } })));
        }
        return (React.createElement("pre", null,
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } }),
            React.createElement("code", null,
                React.createElement("span", { style: { color: '#B01A03' } }, "curl"),
                " -X",
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, "'POST'"),
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, process.env.NODE_ENV === 'production'
                    ? `'https://api.rover.io/graphql'`
                    : `'https://api.staging.rover.io/graphql'`),
                ' ',
                "\\"),
            React.createElement("code", null,
                '  ',
                "-H",
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, "'accept: application/json'"),
                ' ',
                "\\"),
            React.createElement("code", null,
                '  ',
                "-H",
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, "'content-type: application/json'"),
                ' ',
                "\\"),
            React.createElement("code", null,
                '  ',
                "-H",
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, "'x-rover-api-key:"),
                React.createElement("span", { style: { color: '#D64292' } }, " SERVER_TOKEN"),
                React.createElement("span", { style: { color: '#669900' } }, "'"),
                " \\"),
            React.createElement("code", null,
                '  ',
                "--data-binary",
                ' ',
                React.createElement("span", { style: { color: '#669900' } }, `'{`)),
            React.createElement("code", null,
                '    ',
                React.createElement("span", { style: { color: '#669900' } }, `"variables": {`)),
            React.createElement("code", null,
                '      ',
                React.createElement("span", { style: { color: '#669900' } }, "\"id\":"),
                React.createElement("span", { style: { color: '#D64292' } },
                    " ",
                    id),
                React.createElement("span", { style: { color: '#669900' } }, ",")),
            React.createElement("code", null,
                '      ',
                React.createElement("span", { style: { color: '#669900' } }, "\"to\": ["),
                React.createElement("span", { style: { color: '#D64292' } }, "\"DEVICE_ID\", ..."),
                React.createElement("span", { style: { color: '#669900' } }, "],")),
            React.createElement("code", null,
                '      ',
                React.createElement("span", { style: { color: '#669900' } }, '"fields": {')),
            fields.map((field, index) => {
                if (index === fields.length - 1) {
                    return (React.createElement("code", { key: index },
                        '        ',
                        React.createElement("span", { style: { color: '#669900' } },
                            "\"",
                            field,
                            "\""),
                        ":",
                        ' ',
                        React.createElement("span", { style: { color: '#D64292' } },
                            "\"",
                            field.toUpperCase(),
                            "\"")));
                }
                return (React.createElement("code", { key: index },
                    '        ',
                    React.createElement("span", { style: { color: '#669900' } },
                        "\"",
                        field,
                        "\""),
                    ":",
                    React.createElement("span", { style: { color: '#D64292' } },
                        ' ',
                        "\"",
                        field.toUpperCase(),
                        "\""),
                    ","));
            }),
            React.createElement("code", null,
                '      ',
                React.createElement("span", { style: { color: '#669900' } }, "}")),
            React.createElement("code", null,
                '    ',
                React.createElement("span", { style: { color: '#669900' } }, "},")),
            React.createElement("code", null,
                '    ',
                React.createElement("span", { style: { color: '#669900' } }, "\"operationName\": \"CampaignSendNotification\",")),
            React.createElement("code", null,
                '    ',
                React.createElement("span", { style: { color: '#669900' } }, `"query": "mutation CampaignSendNotification($id:ID!,$to:[String!]!,$fields:JSON!){campaignSendNotification(id:$id,to:$to,fields:$fields)}"`)),
            React.createElement("code", null,
                '  ',
                React.createElement("span", { style: { color: '#669900' } }, `}'`)),
            React.createElement("div", { style: {
                    height: 16,
                    width: '1.5em',
                    background: '#f5f5f5'
                } })));
    }
}
const mapStateToProps = (state) => ({
    campaign: reducers_1.getEditableCampaign(state)
});
exports.default = react_redux_1.connect(mapStateToProps, {})(APITriggerPreview);
